import React, { createContext, useState, useContext } from "react";
import { PreferenceAssetDetail } from "../@types/UserPreferences";
import { ThemeProvider } from "./ThemeProvider";
import { AnalysisTypePreferencesProvider } from "./AnalysisTypePreferencesContext";
import TourWrapper from "../components/TourWrapper/TourWrapper";

export interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export interface IGeneralContext {
  userFollowingAssets: PreferenceAssetDetail[];
  setUserFollowingAssets: React.Dispatch<
    React.SetStateAction<PreferenceAssetDetail[]>
  >;
  tourStart: Boolean;
  setTourStart: React.Dispatch<React.SetStateAction<Boolean>>;
  showTourButtons: Boolean;
  setShowTourButtons: React.Dispatch<React.SetStateAction<Boolean>>;
  disablePrev: Boolean;
  setDisablePrev: React.Dispatch<React.SetStateAction<Boolean>>;
}

export const GeneralContext = createContext<IGeneralContext>(
  {} as IGeneralContext
);

export const GeneralProvider = ({ children }: Props) => {
  const [userFollowingAssets, setUserFollowingAssets] = useState<
    PreferenceAssetDetail[]
  >([]);
  const [tourStart, setTourStart] = useState<Boolean>(false);
  const [showTourButtons, setShowTourButtons] = useState<Boolean>(false);
  const [disablePrev, setDisablePrev] = useState<Boolean>(false);

  return (
    <GeneralContext.Provider
      value={{ userFollowingAssets, setUserFollowingAssets, tourStart, setTourStart, showTourButtons, setShowTourButtons, disablePrev, setDisablePrev }}
    >
      <ThemeProvider>
        <TourWrapper>
          <AnalysisTypePreferencesProvider>
            {children}
          </AnalysisTypePreferencesProvider>
        </TourWrapper>
      </ThemeProvider>
    </GeneralContext.Provider>
  );
};

export default function useGeneralContext() {
  const context = useContext(GeneralContext);

  if (!context) {
    throw new Error("useGeneralContext must be used whithin an app");
  }

  return context;
}
